import { Box } from '@chakra-ui/react'
import React from 'react'

interface AssignNewDealerOptionsProps {
    clickHandler: (args:any) => void
}

function AssignNewDealerOptions({clickHandler}:AssignNewDealerOptionsProps) {
  return (
    <Box className='assign-dropdown-option-wrapper'>
        <Box className='assign-dropdown-option' onClick={() => clickHandler(0)} >Compliance agent selection</Box>
        <Box className='assign-dropdown-option' onClick={() => clickHandler(1)}>Customer selection</Box>
    </Box>

  )
}

export default AssignNewDealerOptions
